import { Component, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {IstanzaService} from "../../services/istanza.service";
import {Istanza} from "../../models/istanza";
import {UserData} from "../../models/user-data";
import {delay} from "rxjs";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {TributiService} from "../../services/tributi.service";
import {Router} from "@angular/router";
import {MessageService} from "../../services/message.service";
import {ToolbarService} from "../../services/toolbar.service";
import {Toolbar} from "../../models/toolbar";
import {Account} from "../../core/auth/account.model";

import {AlertService} from "../../shared/alert/alert.service";
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import {zonedTimeToUtc} from "date-fns-tz";
import {parse} from "date-fns";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import { ConfigurazioneGeneraleService } from '../../services/configurazione-generale.service';

type nullString = string | null | undefined;

@Component({
  selector: 'jhi-istanze-emesse',
  templateUrl: './istanze-emesse.component.html',
  styleUrls: ['./istanze-emesse.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class IstanzeEmesseComponent extends SubscriptionManager implements OnInit {
  @ViewChild('_MD_INTEGRAZIONE') _md_integrazione!: ElementRef;
  istanze: Array<Istanza>
  userData: UserData;
  paginaCorrente: number;
  idIstanzaCliccata: string;
  formFilter!: FormGroup;
  serviziToolbar!: Array<Toolbar>;
  statoFiltra: string;
  loading: boolean;
  mapStati: Map<string, { cdStato: string, colore: string }>;
  account: Account;
  cambiaStatoForm: FormGroup;
  modalOpen: boolean;
  modalErrorOpen: boolean;
  modalTextError: string;
  creaIntegrazioneForm: FormGroup;
  idIstanza: nullString;
  windowSize: number;
  Isfirst: string;
  Islast: string;
  Totalpages: number;
  Totalelement: string;
  selectedLanguage: string = this.translateService.currentLang;
  countFiltri: number;
  txtNuovaIst: string;

  constructor(private istanzaService: IstanzaService, private configurazioneGeneraleService: ConfigurazioneGeneraleService, private translateService: TranslateService, private toolbarService: ToolbarService, private _fb: FormBuilder, private tributiService: TributiService, private router: Router, private messageService: MessageService, private alertService: AlertService) {
    super();
    this.loading = false;
    this.istanze = [];
    this.paginaCorrente = 0;
    this.statoFiltra = "";
    this.idIstanzaCliccata = "0";
    this.userData = JSON.parse(localStorage.getItem('userData') ?? '{}');
    this.mapStati = new Map<string, { cdStato: string, colore: string }>([
      ["Bozza", {cdStato: "00", colore: 'blue'}],
      ["Protocollata", {cdStato: "01", colore: ''}],
      ["Da integrare", {cdStato: "02", colore: 'red'}],
      ["Integrata", {cdStato: "03", colore: 'sky'}],
      ["Evasa", {cdStato: "04", colore: 'green'}],
      ["Preso in carico", {cdStato: "05", colore: 'orange'}]
    ]);
    this.account = JSON.parse(localStorage.getItem("acc") ?? '{}');
    this.cambiaStatoForm = this._fb.group({
      id: [""],
      stato: {
        codice: [""]
      }
    });
    this.modalOpen = false;
    this.modalErrorOpen = false;
    this.windowSize = window.innerWidth;
    this.modalTextError = "";
    this.creaIntegrazioneForm = this._fb.group({
      idDipendente: [this.userData.id],
      nota: ["", Validators.required],
      idIstanza: {
        id: [""]
      },
      idTipoIntegrazione: {
        id: '1',
      }
    });
    this.idIstanza = "";
    this.Isfirst = '';
    this.Islast = '';
    this.Totalpages = 0;
    this.Totalelement = '';
    this.countFiltri = 0;
    this.txtNuovaIst = '';
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.windowSize = event.target.innerWidth;
  }

  ngOnInit(): void {
    if (window.history.state.messaggio) {
      this.alertService.creaAlert(window.history.state.messaggio, "success", "sticky", 3000, true);
    }
    if(window.history.state.descrizione){
      this.txtNuovaIst = window.history.state.descrizione;
    }
    this.formFilter = this._fb.group({
      istanza: this._fb.group({
        idRichiedente: '',
        servizio: {cdServizio: ""},
        stato: this._fb.group({codice: "", descrizione: ""})
      }),
      numEl: ["10"],
      pagamento: [""],
      page: [this.paginaCorrente.toString()],
      dataInizio: [""],
      dataFine: [""],
      id:[0],
      protocolloNumero: [null],
      protocolloAnno: [null]
    })
    this.subs.sink = this.formFilter.controls['numEl'].valueChanges
      .pipe(delay(100))
      .subscribe(
        {
          next: () => {
            this.getIstanzaPageUser();
          }
        })
    this.getIstanzaPageUser();
    this.subs.sink = this.translateService.onLangChange.subscribe((langChangeEvent: LangChangeEvent) => {
      this.selectedLanguage = langChangeEvent.lang
    });
  }

  paginaPrecedente(): void {
    this.paginaCorrente--;
    this.formFilter.patchValue({
      page: this.paginaCorrente.toString()
    })
    this.getIstanzaPageUser();
  }

  paginaSuccessiva(): void {
    this.paginaCorrente++;
    this.formFilter.patchValue({
      page: this.paginaCorrente.toString()
    })
    this.getIstanzaPageUser();
  }

  vaiAPagina(index: number): void {
    this.paginaCorrente = index;
    this.formFilter.patchValue({
      page: this.paginaCorrente.toString()
    })
    this.getIstanzaPageUser();

  }

  formatDate(date: string): Date {
    return zonedTimeToUtc(parse(date, "yyyy-MM-dd", new Date()), 'Europe/Rome');
  }

  getIstanzaPageUser(): void {
    this.istanze = [];
    this.loading = true;
    this.formFilter.get('istanza')?.get('stato')?.get('codice')?.setValue(this.mapStati.get(<string>this.formFilter.get('istanza')?.get('stato')?.get('descrizione')?.value)?.cdStato)
    this.countFiltriApplicati();
    this.subs.sink = this.istanzaService.istanzaPaginazione(this.formFilter.value).subscribe({
      next: (res) => {
        if (res.body) {
          this.istanze = res.body;
          this.Isfirst = <string>res.headers.get('Isfirst');
          this.Islast = <string>res.headers.get('Islast');
          this.Totalpages = Number(res.headers.get('Totalpages'));
          this.Totalelement = <string>res.headers.get('Totalelement');
        }
      },
      error: () => {
        this.loading = false
      },
      complete: () => {
        this.subs.sink = this.toolbarService.getToolbar().subscribe({
          next: (toolbar) => {
            this.serviziToolbar = toolbar;
          },
          error: () => {
            this.loading = false
          },
          complete: () => {
            this.loading = false
          }
        })
      }
    })
  }

  eliminaIstanza(): void {
    this.subs.sink = this.istanzaService.eliminaIstanza(this.idIstanzaCliccata).subscribe({
      next: () => {
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
      complete: () => {
        this.getIstanzaPageUser()
      }
    })
  }

  setClickedIstanza(id: any): void {
    this.idIstanzaCliccata = id;
  }

  goToBozza(codiceServizio: string): void {
    this.router.navigate(["Servizi/NuovaIstanza"], {queryParams: {servizio: codiceServizio}, state: {previousRoute: "Servizi/IstanzeEmesse"}}).then();
  }

  getIntegrazione(id: nullString): void {
    void this.router.navigate(['Servizi/integrazioneIstanza/' + <string>id], {state: {previousRoute: "/Servizi/IstanzeEmesse"}});
  }

  goToNuovaIstanza():void{
    return void this.router.navigate(["Servizi/NuovaIstanza"], {queryParams: {servizio: window.history.state.codice}, state: {previousRoute: "Servizi/IstanzeEmesse"}}).then();
  }

  goToHome():void{
    window.location.href = this.configurazioneGeneraleService.configurazione.linkHome;
  }

  removeFilters(): void {
    this.formFilter.get('dataInizio')?.reset();
    this.formFilter.get('dataFine')?.reset();
    this.formFilter.get('id')?.reset();
    this.formFilter.get('istanza')?.get('stato')?.get('descrizione')?.setValue("");
  }

  goToDettaglioIstanza(id: string | null | undefined): void {
    this.router.navigate(['Servizi/DettaglioIstanza/' + <string>id]).then();
  }

  goToPagamento(id: string | null | undefined): void {
    this.router.navigate(['Servizi/integrazionePagamenti/' + <string>id]).then();
  }

  goBack(): void {
    if (window.history.state.previousRoute) {
      this.router.navigate([window.history.state.previousRoute]).then();
    } else {
      this.router.navigate(['/home']).then();
    }
  }

  checkPreviousRouteCruscotto():boolean{
    return window.history.state.previousRoute === 'Cruscotto/le-mie-attivita';
  }

  goToCruscotto():void{
    return void this.router.navigate(['Cruscotto/le-mie-attivita'], {state: {cambioVisuale: true}}).then();
  }

  checkNuovaIstanza():boolean{
    return window.history.state.codice !== undefined;
  }

  countFiltriApplicati(): void {
    this.countFiltri = 0;
    const controlsFilter = this.formFilter.controls;
    for (const controlFilter in controlsFilter) {
      if (
        controlsFilter[controlFilter].value != null &&
        controlsFilter[controlFilter].value !== '' &&
        controlFilter !== 'numEl' &&
        controlFilter !== 'page'
      ) {
        if (controlFilter === 'istanza') {
          if ((controlsFilter[controlFilter].value).stato.codice !== undefined) {
            this.countFiltri++;
          }
        } else {
          this.countFiltri++;
        }
      }
    }
  }
}
